import { useMutation } from "urql";

import { UpdateCollectionDocumentDocument } from "../../../graphql/generated.ts";

export function useUpdateCollectionDocument() {
  return useMutation(UpdateCollectionDocumentDocument);
}
